var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftbackgr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 510,
    viewBox: "0 0 89 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246 0H0V674H246V0Z",
    fill: "#85959A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftbackgr);
export default __webpack_public_path__ + "static/media/leftbackgr.99e25cb257db80de0821ba036a0bfc68.svg";
export { ForwardRef as ReactComponent };